import type { FC } from 'react'

export const HomeHeroAssets: FC = () => {
	return (
		<div
			className="absolute bottom-0 left-0 z-10 h-full w-full pointer-events-none"
			aria-hidden="true"
		>
			{/* Mobile Assets */}
			<div className="relative flex h-full w-full flex-col justify-between tablet-p:hidden overflow-hidden">
				<svg
					viewBox="0 0 155 128"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="w-38.75 h-auto self-end -mt-px"
				>
					<path
						d="M155.001 128.007L45.7344 18.7441C33.7321 6.74241 17.4538 2.22176e-05 0.480469 0H155.001V128.007Z"
						fill="white"
					/>
					<path
						d="M155 104L78.3137 27.3137C68.2343 17.2343 75.3729 0 89.6274 0H155V104Z"
						fill="#005EB8"
					/>
				</svg>
				<svg
					className="absolute -bottom-px left-0 w-15.5 h-auto self-start"
					viewBox="0 0 63 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0 0.988281L17.2666 18.2549C29.2688 30.2566 45.5472 36.9989 62.5205 36.999H0V0.988281Z"
						fill="white"
					/>
				</svg>
			</div>
			{/* Tablet and desktop Assets */}
			<div className="relative h-full w-full flex-col justify-between hidden tablet-p:flex">
				<svg
					viewBox="0 0 358 305"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="w-67 h-auto self-end -mt-px desktop:w-89.5"
				>
					<path
						d="M357.999 304.013L91.4658 37.4883C67.4613 13.4847 34.9039 0 0.957031 0H357.999V304.013Z"
						fill="white"
					/>
					<path
						d="M358 272L140.627 54.6274C120.469 34.4686 134.746 0 163.255 0H358V272Z"
						fill="#005EB8"
					/>
				</svg>
				<svg
					viewBox="0 0 126 73"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="absolute -bottom-px left-0 w-23.5 h-auto self-start desktop:w-31.5"
				>
					<path
						d="M0 0.976562L34.5332 35.5088C58.5378 59.5127 91.0949 72.998 125.042 72.998H0V0.976562Z"
						fill="white"
					/>
				</svg>
			</div>
		</div>
	)
}

export default HomeHeroAssets
